import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-927cebc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "components__rec-filter-bar" }
const _hoisted_2 = ["onUpdate:modelValue"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "frontend-icon fi-close" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Filter zurücksetzen", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]

import { computed } from "vue";
  import { useStore } from "vuex";
  import { themingCssClass } from "../../mixins/theming-mixin"
  import { recProps } from '../../mixins/rec-component';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'rec-filter-bar',
  props: {...recProps()},
  setup(__props) {

  
  
  const store = useStore();
  const filters = computed(()=> store.state.filter.definitions);

  const reset = ()=> { store.commit("resetFilter");}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filters.value, (filter) => {
      return (_openBlock(), _createElementBlock("div", {
        key: filter.key,
        class: "filter-entry"
      }, [
        _createElementVNode("label", null, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": ($event: any) => ((filter.checked) = $event)
          }, null, 8, _hoisted_2), [
            [_vModelCheckbox, filter.checked]
          ]),
          (typeof filter.value == 'number')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(filter.value) + " (" + _toDisplayString(filter.label) + ")", 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(filter.label), 1)
              ], 64))
        ])
      ]))
    }), 128)),
    _createElementVNode("div", {
      class: _normalizeClass(["filter-remove", [_unref(themingCssClass)('normal')]]),
      onClick: reset
    }, _hoisted_5, 2)
  ]))
}
}

})